import { useState, useEffect, useRef } from "react";

const useComponentVisible = (initialIsVisible: any) => {
  const [disableHide, setDisableHide] = useState(false);
  const [isComponentVisible, setIsComponentVisible] = useState(
    initialIsVisible
  );
  const ref = useRef(null);

  const handleHide = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      setIsComponentVisible(false);
    }
  };

  const handleClickOutside = (event: any) => {
    // @ts-ignore
    if (ref.current && !ref.current.contains(event.target) && !disableHide) {
      setIsComponentVisible(false);
    }

    if(disableHide) {
      setDisableHide(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleHide, true);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("keydown", handleHide, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return { ref, isComponentVisible, setIsComponentVisible, setDisableHide };
};

export default useComponentVisible;
